// canvas を端末の画面密度に合わせて用意する。
//
// canvas は「実際のピクセル数（width/height 属性）」と「表示サイズ（CSS）」が別物。
// 揃えないと、スマホのような高密度ディスプレイでは 1倍で描いた絵が
// 2〜3倍に引き伸ばされて表示され、輪郭がぼやけて見える。
//
// ここでは実ピクセルを devicePixelRatio 倍に増やし、表示サイズは CSS で元のまま固定する。
// あわせて描画コンテキストを同じ倍率で拡大しておくので、
// 呼び出し側の座標計算は今までどおり CSS ピクセルのまま書ける。

// 倍率の上限。青天井にしない理由:
//   このアプリは全画面 canvas を10枚以上（壁・ソファ・机2枚・キャラ7体）重ねている。
//   iPhone は devicePixelRatio が 3 のものがあり、そのまま使うと
//   面積が9倍＝メモリも9倍になり、モバイルのブラウザに落とされる危険がある。
//   2 に抑えれば見た目はほぼ改善しつつ、消費は 4倍で収まる。
const MAX_DPR = 2;

export function getDpr() {
  return Math.min(window.devicePixelRatio || 1, MAX_DPR);
}

/**
 * canvas を CSS サイズ cssW×cssH で表示しつつ、実ピクセルは dpr 倍で確保する。
 * 戻り値の cssW / cssH を使って描画の座標計算を行うこと
 * （canvas.width をそのまま使うと dpr 倍の値になってしまう）。
 */
export function sizeCanvas(canvas, cssW, cssH) {
  const dpr = getDpr();
  canvas.width = Math.round(cssW * dpr);
  canvas.height = Math.round(cssH * dpr);
  canvas.style.width = `${cssW}px`;
  canvas.style.height = `${cssH}px`;

  const ctx = canvas.getContext('2d');
  // 以降の描画命令は CSS ピクセル基準で書ける
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  return { cssW, cssH, dpr };
}

/** その canvas の表示サイズ（CSS ピクセル）を返す */
export function cssSize(canvas) {
  const dpr = getDpr();
  return { cssW: canvas.width / dpr, cssH: canvas.height / dpr };
}
